import PropTypes from 'prop-types';

import { H2Section } from 'bloko/blocks/header';

const TitlePage = ({ children }) => <H2Section lite>{children}</H2Section>;

TitlePage.propTypes = {
    children: PropTypes.node,
};

export default TitlePage;
